// Public contact details shown across the site. Update them here, not in the pages.
export const CONTACT_EMAIL = 'info@acceleroindonesia.org'
export const WHATSAPP_NUMBER = '6282343117956'
export const WHATSAPP_DISPLAY = '+62 823-4311-7956'

export const whatsAppLink = (text?: string): string =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ''}`
